// removed by extract-text-webpack-plugin
module.exports = {"left":"typeL__left___X17zB breakPointL-textAlign-left","center":"typeL__center___2s8hv breakPointL-textAlign-center","right":"typeL__right___87tRJ breakPointL-textAlign-right","top":"typeL__top___2ogOh breakPointL-display-tableCell breakPointL-verticalAlign-top","middle":"typeL__middle___3moIl breakPointL-display-tableCell breakPointL-verticalAlign-middle","bottom":"typeL__bottom___1Yg_X breakPointL-display-tableCell breakPointL-verticalAlign-bottom"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-align/Align/style/typeL.css
// module id = 82
// module chunks = 0 16